
import New2 from '../Altara/Adi (1).webp'
import New3 from '../Altara/Adi (2).webp'
import New4 from '../Altara/Adi (3).webp'
import New5 from '../Altara/Adi (4).webp'
import New6 from '../Altara/Adi (5).webp'
import New7 from '../Altara/Adi (6).webp'
import New8 from '../Altara/Adi (7).webp'
import New9 from '../Altara/Adi (8).webp'
import New10 from '../Altara/Adi (9).webp'
import New11 from '../Altara/Adi (10).webp'


const Newimages =[
    New2,New3,New4,New5,New6,New7,New8,New9,New10,New11
]

export default Newimages;